import EmailSettingCard from "./emailSettingCard.container";

export default EmailSettingCard;
